import {ObjectChangeLog} from "../../../model/object-change-log";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectChangeLogSelectorProps = {};

export const objectChangeLogSelector = () => createSelector(
  [getUseQueryResultData<ObjectChangeLog>],
  (data) => {
    return data ? transformObjectChangeLog(data) : undefined;
  }
);

export const objectChangeLogsSelector = () => createSelector(
  [getUseQueryResultData<ObjectChangeLog[]>],
  (data) => {
    return selectObjectChangeLogsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectChangeLog = (value: ObjectChangeLog): ObjectChangeLog => {
  return {...value}
}

export const selectObjectChangeLogs = (values?: ObjectChangeLog[], selector?: ObjectChangeLogSelectorProps): ObjectChangeLog[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectChangeLogsAndTransform = (values?: ObjectChangeLog[], selector?: ObjectChangeLogSelectorProps): ObjectChangeLog[] => {
  const selected = selectObjectChangeLogs(values, selector);
  return selected.map(transformObjectChangeLog);
};
